// @flow
export const LOGIN = 'LOGIN'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const LOGOUT_FAILED = 'LOGOUT_FAILED'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const PROFILE = 'PROFILE'
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS'
export const PROFILE_FAILED = 'PROFILE_FAILED'

export function login(payload: Object): Object {
  return {
    type: LOGIN,
    payload
  }
}

export function loginFailed(payload: Object): Object {
  return {
    type: LOGIN_FAILED,
    payload
  }
}

export function loginSuccess(payload: Object): Object {
  return {
    type: LOGIN_SUCCESS,
    payload
  }
}

export function profile(): Object {
  return {
    type: PROFILE
  }
}

export function profileSuccess(payload: Object): Object {
  return {
    type: PROFILE_SUCCESS,
    payload
  }
}

export function profileFailed(payload: Object): Object {
  return {
    type: PROFILE_FAILED,
    payload
  }
}

export function logout(skipRedirect = false): Object {
  return {
    type: LOGOUT,
    skipRedirect
  }
}

export function logoutFailed(payload: Object): Object {
  return {
    type: LOGOUT_FAILED,
    payload
  }
}

export function logoutSuccess(): Object {
  return {
    type: LOGOUT_SUCCESS
  }
}
